import { Accordion, FormSection, RadioButton, Text, TextInput } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const MARGIN_COPY_CATEGORY = "35px";

export interface RootTypeProps {
	rootType: string;
}

const AttributeDefinitionRootType: FunctionComponent<RootTypeProps> = observer((props) => {
	const {
		rootType,
	} = props;

	const store = useAttributeDefinitionStore();
	const { 
		attrCopyCategories,
		getCopyOptionsOptions,
		isCopyOptionsDisabled,
		locale,
		onChangeCopyCategory,
	} = store;

	const {
		labelCopyCategoryRes,
	} = locale;

	const ref = useRef(rootType);

	const attrCopyCategory = attrCopyCategories[rootType];
	const options = store.getCopyOptionsOptions(attrCopyCategory);
	const defaultExpanded = Object.keys(attrCopyCategories).indexOf(rootType) === 0;

	const _onChangeCopyCategory = (newValue: string): void => {
		onChangeCopyCategory(newValue, ref.current);
	};

	return (
		<Accordion 
			defaultExpanded = {defaultExpanded}
			key={rootType}
			title={rootType}
		>
			<RadioButton
				ariaLabelRes={labelCopyCategoryRes}
				disabled={isCopyOptionsDisabled}
				key={rootType}
				labelRes={labelCopyCategoryRes}
				onChange={_onChangeCopyCategory}
				options={options}
				value={attrCopyCategory}
			/>	
		</Accordion>
	);
});

const AttributeDefinitionSectionCopyOptions: FunctionComponent = observer(() => {
	const { 
		attrCopyCategories,
		attrCopyOptionsName,
		attrCopyOptionsNameError,
		isCopyOptionsDisabled,
		isCopyOptionsNameVisible,
		locale,
		onChangeCopyOptionsName,
	} = useAttributeDefinitionStore();

	const {
		helperTextCopyOptionsNameRes,
		labelCopyOptionsRes,
		labelCopyOptionsName,
		labelCopyOptionsNameNoteRes,
	} = locale;

	return (
		<>
			<FormSection titleRes={labelCopyOptionsRes} />
			{ Object.keys(attrCopyCategories).map((key) => {
				return (<AttributeDefinitionRootType key={key} rootType={key} />);
			})}
			<div style={{ marginLeft: MARGIN_COPY_CATEGORY }}>
				{isCopyOptionsNameVisible && (
					<>
						<Text childrenRes={labelCopyOptionsNameNoteRes} />
						<br />
						<TextInput
							dataCsiAutomation="CopyOptionsName"
							disabled={isCopyOptionsDisabled}
							error={!!attrCopyOptionsNameError}
							errorMessage={attrCopyOptionsNameError}
							helperTextRes={helperTextCopyOptionsNameRes}
							label={labelCopyOptionsName}
							onChange={onChangeCopyOptionsName}
							required
							value={attrCopyOptionsName}
						/>
					</>
				)}
			</div>
		</>
	);
});

export default AttributeDefinitionSectionCopyOptions;